<template>
  <el-upload
    ref="upload"
    :auto-upload="false"
    :multiple="false"
    :limit="1"
    :file-list="fileList"
    :show-file-list="false"
    action=""
    :on-change="handleChange">
    <div v-if="type === 'btn'">
      <el-button :type="btnType" :disabled="disabled" :size="size" icon="el-icon-upload2">{{ tip ? tip : '上传文件'}}</el-button>
    </div>
    <div v-else>
      <div v-if="!value" class="upload">
        <img src="../../../assets/images/14@2x.png" width="88" height="70" alt="">
        <p>{{ tip }}</p>
        <p v-if="maxTip">{{ maxTip }}</p>
      </div>
      <el-image
        v-else
        fit="cover"
        style="width: 140px; height: 140px;"
        :src="value" />
    </div>
  </el-upload>
</template>

<script>
import { validateFile } from '@/utils/util'
export default {
  name: 'UiUpload',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    fileType: {
      type: String,
      default: () => 'image'
    },
    tip: {
      type: String,
      default: '点击添加照片'
    },
    value: String,
    type: {
      type: String,
      default: ''
    },
    btnType: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: ''
    },
    maxTip: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      fileList: []
    }
  },

  methods: {
    httpR(file) {
      this.$emit('submit', file);
    },
    clearFiles() {
      this.$refs.upload.clearFiles();
    },
    handleChange(file) {
      if (validateFile(file, this.fileType)) {
        this.httpR(file.raw)
        this.clearFiles()
      } else {
        this.fileList = []
        this.$message.error('文件格式错误！')
      }
    },
    // validate(file) {
    //   const { name, size } = file;
    //   let reg, suffixMsg;

    //   if (this.fileType == 'excel') {
    //     reg = /xlsx?/i;
    //     suffixMsg = '上传文件的后缀只能是xls或xlsx';
    //   } else if (this.fileType == 'doc') {
    //     reg = /pdf|docx?/i;
    //     suffixMsg = '上传文件的后缀只能是pdf或doc';
    //   } else if (this.fileType == 'docexcel') {
    //     reg = /pdf|docx?|xlsx?/i;
    //     suffixMsg = '上传文件的后缀只能是pdf或doc或xls或xlsx';
    //   } else {
    //     reg = /jpe?g|png/i;
    //     suffixMsg = '上传文件的后缀只能是jp(e)g或png';
    //   }

    //   if (!reg.test(name)) {
    //     return this.$message.error(suffixMsg);
    //   }
    //   // if (size / 1024 / 1024 > 2) {
    //   //   return this.$message.error('上传文件的大小不能超过2MB');
    //   // }
    //   return true;
    // }
  }
}
</script>
<style scoped>
  .upload {
    padding: 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #999;
    line-height: 16px;
    text-align: center;
    width: 140px;
    height: 140px;
    background: #F6F7F9;
  }
  
  </style>
